<script>
    import NavBar from "../components/NavBar.svelte";
    import Foot from "../components/Foot.svelte";
</script>

<NavBar/>


<main class="page-main">
    Lobby
</main>
<Foot/>
